import React from 'react';

import PublicationsList from './PublicationsList';
import ThesesList from './ThesesList';

const Products = ({
  data1: publications,
  data2: theses,
  onAddPublication,
  onAddThesis,
  onChange,
  onDelete,
}) => {
  return (
    <>
      <PublicationsList
        data={publications}
        onAddPublication={onAddPublication}
        onChange={onChange}
        onDelete={onDelete}
      />
      <ThesesList
        data={theses}
        onAddThesis={onAddThesis}
        onChange={onChange}
        onDelete={onDelete}
      />
    </>
  );
};

export default Products;
